module.exports = "<p ng-repeat=\"guestListEntry in $ctrl.data\">\r\n    <strong>{{guestListEntry.expectedArrival | date:'medium'}}</strong><br/>\r\n    <span ng-if=\"!guestListEntry.guest.isBusiness\">{{guestListEntry.guest.firstName}} {{guestListEntry.guest.middleName}} {{guestListEntry.guest.lastName}}</span>\r\n    <span ng-if=\"guestListEntry.guest.isBusiness\">{{guestListEntry.guest.business}} (Business)</span>\r\n</p>\r\n<p ng-if=\"!$ctrl.data || $ctrl.data.length == 0\">\r\n    No guest expected today\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/piper-expected-today-widget/piper-expected-today-widget.component.html
// module id = 590
// module chunks = 0